import React from 'react';

function Spain(props) {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_800_124140)">
        <mask
          id="mask0_800_124140"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124140)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#FFB400"
          />
          <mask
            id="mask1_800_124140"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124140)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V6H36V0H0Z"
              fill="#C51918"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 18V24H36V18H0Z"
              fill="#C51918"
            />
            <rect
              x="5.63428"
              y="10.272"
              width="1.26"
              height="5.824"
              fill="#F1F9FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.39837 9.26398H5.13037V9.82398H5.50838V10.272H7.02038V9.82398H7.39837V9.26398Z"
              fill="#C88A02"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.02037 16.432H7.39837V16.992H5.13037V16.432H5.50837V15.984H7.02037V16.432Z"
              fill="#C88A02"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.26432 9.37598C6.53852 9.37598 6.56639 9.28421 6.72816 9.14713C6.85378 9.04069 7.14632 8.90869 7.14632 8.75998C7.14632 8.41977 6.75144 8.14398 6.26432 8.14398C5.77721 8.14398 5.38232 8.41977 5.38232 8.75998C5.38232 8.92565 5.58379 9.03642 5.73612 9.14713C5.89661 9.26377 6.01441 9.37598 6.26432 9.37598Z"
              fill="#AD1619"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.13037 16.9919H7.39837V17.8879C7.39837 17.8879 7.11487 17.7759 6.83137 17.7759C6.54787 17.7759 6.26437 17.8879 6.26437 17.8879C6.26437 17.8879 5.98087 17.7759 5.69737 17.7759C5.41387 17.7759 5.13037 17.8879 5.13037 17.8879V16.9919Z"
              fill="#005BBF"
            />
            <mask
              id="mask2_800_124140"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="5"
              y="16"
              width="3"
              height="2"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.13037 16.9919H7.39837V17.8879C7.39837 17.8879 7.11487 17.7759 6.83137 17.7759C6.54787 17.7759 6.26437 17.8879 6.26437 17.8879C6.26437 17.8879 5.98087 17.7759 5.69737 17.7759C5.41387 17.7759 5.13037 17.8879 5.13037 17.8879V16.9919Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_800_124140)">
              <path
                d="M5.10956 17.7119L5.06006 17.6046C5.26433 17.5238 5.46934 17.4832 5.67465 17.4832C5.8073 17.4832 5.87657 17.4997 5.99432 17.5462C6.09776 17.5872 6.15137 17.5999 6.26449 17.5999C6.37761 17.5999 6.43123 17.5872 6.53466 17.5462C6.65242 17.4997 6.72169 17.4832 6.85433 17.4832C7.05964 17.4832 7.26465 17.5238 7.46892 17.6046L7.41942 17.7119C7.23047 17.6371 7.04225 17.5999 6.85433 17.5999C6.74121 17.5999 6.6876 17.6126 6.58416 17.6535C6.46641 17.7001 6.39714 17.7165 6.26449 17.7165C6.13184 17.7165 6.06258 17.7001 5.94482 17.6535C5.84139 17.6126 5.78777 17.5999 5.67465 17.5999C5.48674 17.5999 5.29851 17.6371 5.10956 17.7119Z"
                fill="white"
              />
              <path
                d="M5.10956 17.3759L5.06006 17.2686C5.26433 17.1878 5.46934 17.1472 5.67465 17.1472C5.8073 17.1472 5.87657 17.1637 5.99432 17.2102C6.09776 17.2512 6.15137 17.2639 6.26449 17.2639C6.37761 17.2639 6.43123 17.2512 6.53466 17.2102C6.65242 17.1637 6.72169 17.1472 6.85433 17.1472C7.05964 17.1472 7.26465 17.1878 7.46892 17.2686L7.41942 17.3759C7.23047 17.3011 7.04225 17.2639 6.85433 17.2639C6.74121 17.2639 6.6876 17.2766 6.58416 17.3175C6.46641 17.3641 6.39714 17.3806 6.26449 17.3806C6.13184 17.3806 6.06258 17.3641 5.94482 17.3175C5.84139 17.2766 5.78777 17.2639 5.67465 17.2639C5.48674 17.2639 5.29851 17.3011 5.10956 17.3759Z"
                fill="white"
              />
            </g>
            <rect
              x="17.9819"
              y="10.272"
              width="1.26"
              height="5.824"
              fill="#F1F9FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.746 9.26398H17.478V9.82398H17.8561V10.272H19.3681V9.82398H19.746V9.26398Z"
              fill="#C88A02"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.368 16.432H19.746V16.992H17.478V16.432H17.856V15.984H19.368V16.432Z"
              fill="#C88A02"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.612 9.37598C18.8862 9.37598 18.914 9.28421 19.0758 9.14713C19.2014 9.04069 19.494 8.90869 19.494 8.75998C19.494 8.41977 19.0991 8.14398 18.612 8.14398C18.1249 8.14398 17.73 8.41977 17.73 8.75998C17.73 8.92565 17.9314 9.03642 18.0838 9.14713C18.2443 9.26377 18.3621 9.37598 18.612 9.37598Z"
              fill="#AD1619"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.478 16.9919H19.746V17.8879C19.746 17.8879 19.4625 17.7759 19.179 17.7759C18.8955 17.7759 18.612 17.8879 18.612 17.8879C18.612 17.8879 18.3285 17.7759 18.045 17.7759C17.7615 17.7759 17.478 17.8879 17.478 17.8879V16.9919Z"
              fill="#005BBF"
            />
            <mask
              id="mask3_800_124140"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="17"
              y="16"
              width="3"
              height="2"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.478 16.9919H19.746V17.8879C19.746 17.8879 19.4625 17.7759 19.179 17.7759C18.8955 17.7759 18.612 17.8879 18.612 17.8879C18.612 17.8879 18.3285 17.7759 18.045 17.7759C17.7615 17.7759 17.478 17.8879 17.478 17.8879V16.9919Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_800_124140)">
              <path
                d="M17.4577 17.7119L17.4082 17.6046C17.6125 17.5238 17.8175 17.4832 18.0228 17.4832C18.1554 17.4832 18.2247 17.4997 18.3425 17.5462C18.4459 17.5872 18.4995 17.5999 18.6126 17.5999C18.7258 17.5999 18.7794 17.5872 18.8828 17.5462C19.0006 17.4997 19.0698 17.4832 19.2025 17.4832C19.4078 17.4832 19.6128 17.5238 19.8171 17.6046L19.7676 17.7119C19.5786 17.6371 19.3904 17.5999 19.2025 17.5999C19.0894 17.5999 19.0357 17.6126 18.9323 17.6535C18.8146 17.7001 18.7453 17.7165 18.6126 17.7165C18.48 17.7165 18.4107 17.7001 18.293 17.6535C18.1895 17.6126 18.1359 17.5999 18.0228 17.5999C17.8349 17.5999 17.6467 17.6371 17.4577 17.7119Z"
                fill="white"
              />
              <path
                d="M17.4577 17.3759L17.4082 17.2686C17.6125 17.1878 17.8175 17.1472 18.0228 17.1472C18.1554 17.1472 18.2247 17.1637 18.3425 17.2102C18.4459 17.2512 18.4995 17.2639 18.6126 17.2639C18.7258 17.2639 18.7794 17.2512 18.8828 17.2102C19.0006 17.1637 19.0698 17.1472 19.2025 17.1472C19.4078 17.1472 19.6128 17.1878 19.8171 17.2686L19.7676 17.3759C19.5786 17.3011 19.3904 17.2639 19.2025 17.2639C19.0894 17.2639 19.0357 17.2766 18.9323 17.3175C18.8146 17.3641 18.7453 17.3806 18.6126 17.3806C18.48 17.3806 18.4107 17.3641 18.293 17.3175C18.1895 17.2766 18.1359 17.2639 18.0228 17.2639C17.8349 17.2639 17.6467 17.3011 17.4577 17.3759Z"
                fill="white"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.61159 15.6799C5.83876 15.4351 5.96579 15.2124 5.96579 14.9758C5.96579 14.8267 5.91586 14.6979 5.82838 14.5926L5.84316 14.5867C5.8418 14.5873 6.09237 14.4902 6.17961 14.453C6.34178 14.3839 6.48465 14.3107 6.62395 14.2206C6.71288 14.1631 6.83204 14.1005 7.01369 14.0138C7.04501 13.9989 7.12978 13.9589 7.18406 13.9333L7.18441 13.9331L7.18447 13.9331L7.23047 13.9114C7.31875 13.8695 7.38449 13.8374 7.44557 13.8059C7.63588 13.7078 7.76165 13.6267 7.85784 13.5182C8.08568 13.2614 8.03837 12.9133 7.71911 12.7201C7.56269 12.6254 7.35161 12.5711 7.0422 12.5284L6.97825 12.5196C6.87256 12.505 6.66943 12.4771 6.59968 12.4674C6.45161 12.4467 6.3195 12.4274 6.2017 12.4091C6.97634 12.2946 8.08248 12.3367 8.56904 12.56L9.03148 11.7638C8.03997 11.3088 5.78082 11.3553 4.93692 11.8718C4.31795 12.2508 4.40101 12.8235 5.04502 13.0702C5.31412 13.1732 5.66493 13.2416 6.31411 13.3343C6.20532 13.3904 6.11513 13.4417 6.03109 13.496C5.94586 13.5511 5.85455 13.5979 5.7438 13.6451C5.69082 13.6676 5.53394 13.7289 5.46205 13.7569L5.42592 13.7711C4.90135 13.9831 4.64677 14.2764 4.72285 14.8059L4.76403 15.0925L4.8379 15.1126L5.61159 15.6799ZM4.96315 14.9392L4.96155 14.9433L4.96277 14.9404L4.96315 14.9392ZM18.7943 14.9758C18.7943 15.2124 18.9213 15.4351 19.1485 15.6799L19.9222 15.1126L19.9961 15.0925L20.0373 14.8059C20.1133 14.2764 19.8587 13.9831 19.3342 13.7711L19.2981 13.7569L19.2981 13.7569C19.2262 13.7289 19.0693 13.6676 19.0163 13.6451C18.9055 13.5979 18.8142 13.5511 18.729 13.496C18.645 13.4417 18.5548 13.3904 18.446 13.3343C19.0952 13.2416 19.446 13.1732 19.7151 13.0702C20.3591 12.8235 20.4422 12.2508 19.8232 11.8718C18.9793 11.3553 16.7201 11.3088 15.7286 11.7638L16.1911 12.56C16.6776 12.3367 17.7838 12.2946 18.5584 12.4091C18.4406 12.4274 18.3085 12.4467 18.1604 12.4674C18.0906 12.4771 17.8874 12.5051 17.7817 12.5196L17.7179 12.5284C17.4085 12.5711 17.1974 12.6254 17.041 12.7201C16.7217 12.9133 16.6744 13.2614 16.9023 13.5182C16.9984 13.6267 17.1242 13.7078 17.3145 13.8059C17.3756 13.8374 17.4413 13.8695 17.5296 13.9114L17.5758 13.9331L17.5762 13.9333C17.6305 13.9589 17.7151 13.9989 17.7464 14.0138C17.9281 14.1005 18.0472 14.1631 18.1361 14.2206C18.2755 14.3107 18.4183 14.3839 18.5805 14.453C18.6677 14.4902 18.9183 14.5873 18.9169 14.5867L18.9317 14.5926C18.8442 14.6979 18.7943 14.8267 18.7943 14.9758Z"
              fill="#AD1619"
            />
            <path
              d="M6.66405 12.4L7.03596 12.4684V12.9612C6.63985 13.2421 5.63428 13.7156 5.63428 13.7156V12.4H6.66405Z"
              fill="#F1F9FF"
            />
            <path
              d="M18.354 12.4L17.9821 12.4684V12.9612C18.3782 13.2421 19.3838 13.7156 19.3838 13.7156V12.4H18.354Z"
              fill="#F1F9FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.6233 7.20597V7.04198C15.9752 6.62854 15.2965 6.42181 14.5872 6.42181C13.9073 6.15434 13.219 6.05051 12.5224 6.11034C12.5226 6.10843 12.5227 6.10745 12.5227 6.10745C11.4754 6.01636 10.4198 6.42181 10.4198 6.42181C9.35592 6.42181 8.38379 7.04198 8.38379 7.04198V7.20597L9.65462 8.34049C9.65462 8.34049 10.0123 9.43249 12.5175 9.17584V9.17861C12.5175 9.17861 14.1762 9.13837 14.2927 9.10391C14.339 9.09024 14.3869 9.0778 14.4359 9.06508C14.7608 8.98077 15.1317 8.88452 15.3525 8.34049L16.6233 7.20597ZM12.5175 6.16046C12.4814 6.53806 12.2748 8.81517 12.5175 9.16817V6.16046Z"
              fill="#AD1619"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.35318 8.14957L9.35402 8.14613L8.45996 7.39843L8.5463 7.31686L9.38525 8.01846L9.40672 7.93068C9.54397 7.95721 9.64429 7.96696 9.70276 7.96144V7.80924L9.88873 7.8987C9.9802 7.9427 10.1112 7.95454 10.2837 7.92958C10.4105 7.91125 10.496 7.78043 10.5239 7.50167L10.5804 6.9389L10.7697 7.47825C10.8554 7.72231 10.9861 7.8299 11.1722 7.8299C11.3539 7.8299 11.427 7.77067 11.435 7.62139L11.4579 7.19801L11.6733 7.57617C11.7509 7.71241 11.8579 7.77422 12.0101 7.77422C12.2277 7.77422 12.3731 7.61294 12.3731 7.3599H12.3771H12.6251H12.6291C12.6291 7.61294 12.7745 7.77422 12.9921 7.77422C13.1443 7.77422 13.2513 7.71241 13.3289 7.57617L13.5443 7.19801L13.5672 7.62139C13.5753 7.77067 13.6483 7.8299 13.83 7.8299C14.0161 7.8299 14.1468 7.72231 14.2325 7.47825L14.4218 6.9389L14.4783 7.50167C14.5062 7.78043 14.5918 7.91125 14.7185 7.92958C14.891 7.95454 15.022 7.9427 15.1135 7.8987L15.2995 7.80924V7.96144C15.3579 7.96696 15.4582 7.95721 15.5955 7.93068L15.6353 8.09358L16.5641 7.31686L16.6504 7.39844L15.4947 8.36495C15.3261 8.64098 15.2412 8.82317 15.2412 8.89885C15.2412 9.01431 14.9033 9.08284 14.2437 9.15323C13.727 9.20838 13.1172 9.24539 12.6184 9.25092V9.25163L12.5558 9.25145L12.492 9.25164V9.25091C11.9932 9.24538 11.3834 9.20837 10.8667 9.15322C10.2071 9.08283 9.8692 9.0143 9.8692 8.89884C9.8692 8.88452 9.86616 8.86639 9.86009 8.84453C9.7936 8.76925 9.74685 8.64612 9.71574 8.53504C9.68653 8.48307 9.65317 8.42633 9.61568 8.36494L9.35962 8.15081L9.35318 8.14957ZM15.5468 8.16759C15.3404 8.20007 15.1914 8.1968 15.1124 8.13957C14.9887 8.17156 14.8436 8.17463 14.678 8.15067C14.5011 8.12509 14.3779 8.0205 14.3038 7.847C14.207 7.95659 14.0847 8.02424 13.9381 8.04611C14.7444 8.14775 15.3093 8.29063 15.3093 8.29063C15.3093 8.29063 15.2953 8.39679 15.2615 8.52159C15.2973 8.45626 15.3398 8.38366 15.3889 8.30353L15.401 8.28953L15.5468 8.16759ZM13.5576 8.00354C13.4875 7.97257 13.4315 7.92766 13.391 7.86977C13.3309 7.91697 13.2625 7.95148 13.1866 7.97278C13.3134 7.98139 13.4373 7.99181 13.5576 8.00354ZM12.7418 7.95099C12.6437 7.91067 12.5621 7.84612 12.5011 7.7634C12.4406 7.84553 12.3597 7.90976 12.2625 7.95013C12.3201 7.9486 12.378 7.94753 12.4362 7.94695V7.94644L12.4868 7.94657L12.5373 7.94644V7.94695C12.6059 7.94763 12.6741 7.949 12.7418 7.95099ZM9.70021 8.28186L9.58272 8.18361C9.72375 8.19604 9.82813 8.18425 9.88986 8.13957C10.0135 8.17156 10.1586 8.17463 10.3242 8.15067C10.5011 8.12509 10.6243 8.0205 10.6984 7.847C10.7924 7.95342 10.9105 8.02029 11.0514 8.0441C10.3562 8.13091 9.83755 8.24904 9.70021 8.28186ZM11.8102 7.97122C11.6881 7.97928 11.5685 7.98903 11.4523 8.00003C11.5188 7.96922 11.5722 7.92551 11.6112 7.86977C11.6699 7.91583 11.7364 7.94982 11.8102 7.97122ZM14.9099 8.90104C14.9982 8.93776 15.069 8.90113 15.1249 8.83081C15.1201 8.85023 15.117 8.86779 15.1158 8.88352C15.1084 8.88782 15.0971 8.893 15.0822 8.89856C15.0407 8.91407 14.9773 8.93059 14.8949 8.94731C14.7328 8.98018 14.5021 9.01285 14.2287 9.04203C13.695 9.09899 13.0604 9.13648 12.5558 9.13945C12.051 9.13653 11.4158 9.09903 10.8817 9.04202C10.6083 9.01284 10.3776 8.98017 10.2155 8.9473C10.1464 8.93329 10.0907 8.91941 10.05 8.90616C10.0545 8.90465 10.059 8.90294 10.0636 8.90104C10.3389 8.78656 12.159 8.67912 12.4868 8.66058C12.8145 8.67912 14.6347 8.78656 14.9099 8.90104ZM15.2565 8.88105C15.2562 8.88134 15.2558 8.88172 15.2554 8.88219L15.2563 8.88106L15.2565 8.88105ZM15.2571 8.88052L15.2565 8.88105L15.2571 8.88052Z"
              fill="#C88A02"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5015 5.34705C12.7103 5.34705 12.8795 5.19662 12.8795 5.01105C12.8795 4.82548 12.7103 4.67505 12.5015 4.67505C12.2928 4.67505 12.1235 4.82548 12.1235 5.01105C12.1235 5.19662 12.2928 5.34705 12.5015 5.34705Z"
              fill="#005BBF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.2558 6.99679C12.2638 7.03368 12.2764 7.06802 12.2924 7.09863C12.2435 7.08204 12.1856 7.07243 12.1234 7.07243C11.9494 7.07243 11.8084 7.14765 11.8084 7.24043C11.8084 7.33322 11.9494 7.40843 12.1234 7.40843C12.2974 7.40843 12.4384 7.33322 12.4384 7.24043L12.4383 7.23528L12.4386 7.23539L12.4385 7.24043C12.4385 7.33322 12.5795 7.40843 12.7535 7.40843C12.9274 7.40843 13.0685 7.33322 13.0685 7.24043C13.0685 7.14765 12.9274 7.07243 12.7535 7.07243C12.7096 7.07243 12.6679 7.0772 12.63 7.08583C12.6392 7.03989 12.6388 6.98721 12.6268 6.93268C12.5936 6.78088 12.4837 6.67217 12.3812 6.68988C12.2787 6.70758 12.2226 6.84499 12.2558 6.99679ZM10.4023 7.21062C10.3864 7.18002 10.3738 7.14569 10.3657 7.10882C10.3325 6.95702 10.3887 6.81961 10.4911 6.80191C10.5936 6.7842 10.7036 6.89291 10.7368 7.04471C10.7487 7.09923 10.7491 7.15189 10.74 7.19782C10.7779 7.1892 10.8196 7.18443 10.8634 7.18443C11.0374 7.18443 11.1784 7.25965 11.1784 7.35243C11.1784 7.44522 11.0374 7.52043 10.8634 7.52043C10.6894 7.52043 10.5484 7.44522 10.5484 7.35243L10.5485 7.34741L10.5482 7.34731L10.5483 7.35243C10.5483 7.44522 10.4073 7.52043 10.2333 7.52043C10.0594 7.52043 9.91834 7.44522 9.91834 7.35243C9.91834 7.25965 10.0594 7.18443 10.2333 7.18443C10.2955 7.18443 10.3535 7.19404 10.4023 7.21062ZM14.3486 7.31298C14.3341 7.40486 14.1827 7.4619 14.0104 7.44038C13.8381 7.41886 13.7102 7.32693 13.7248 7.23504C13.7393 7.14316 13.8907 7.08613 14.063 7.10765C14.1245 7.11533 14.1803 7.13199 14.2261 7.15441C14.2151 7.12216 14.208 7.08663 14.2058 7.04914C14.1967 6.89471 14.2738 6.76559 14.3781 6.76073C14.4823 6.75587 14.5742 6.87713 14.5833 7.03155C14.5865 7.08703 14.5787 7.13923 14.5625 7.18359C14.6014 7.17973 14.6435 7.18017 14.6869 7.18559C14.8592 7.20711 14.987 7.29904 14.9725 7.39092C14.958 7.4828 14.8065 7.53984 14.6343 7.51832C14.462 7.4968 14.3341 7.40487 14.3486 7.31299L14.3496 7.30806L14.3493 7.30794L14.3486 7.31298ZM15.5483 7.75724C15.7019 7.82984 15.8661 7.82228 15.9151 7.74036L15.9177 7.73578C15.9329 7.75002 15.9508 7.76038 15.9712 7.76594C16.071 7.79307 16.1932 7.69517 16.244 7.54729C16.2949 7.39941 16.2552 7.25753 16.1554 7.23041C16.0556 7.20328 15.9334 7.30117 15.8826 7.44905C15.8702 7.48497 15.8632 7.52053 15.8611 7.55419C15.8267 7.51918 15.7806 7.48651 15.7257 7.46057C15.5721 7.38797 15.4079 7.39553 15.3589 7.47745C15.3099 7.55938 15.3947 7.68464 15.5483 7.75724ZM9.36586 7.79154C9.21225 7.86414 9.048 7.85658 8.999 7.77466C8.9981 7.77315 8.99724 7.77162 8.99643 7.77009C8.98129 7.78432 8.96338 7.79469 8.94294 7.80024C8.84312 7.82737 8.72097 7.72948 8.6701 7.58159C8.61924 7.43371 8.65893 7.29184 8.75875 7.26471C8.85857 7.23758 8.98072 7.33547 9.03159 7.48336C9.04394 7.51927 9.05095 7.55484 9.05306 7.58849C9.08741 7.55348 9.13351 7.52081 9.1884 7.49487C9.342 7.42227 9.50625 7.42983 9.55526 7.51175C9.60426 7.59368 9.51946 7.71894 9.36586 7.79154Z"
              fill="#C88A02"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.3607 4.0766H12.6232V4.224H12.7947V4.45734H12.6232V4.924H12.7947V5.15734H12.1865V4.924H12.3607V4.45734H12.1865V4.224H12.3607V4.0766Z"
              fill="#C88A02"
            />
            <rect
              x="12.3125"
              y="5.34399"
              width="0.504"
              height="1.456"
              fill="#C88A02"
            />
            <path
              d="M10.2834 5.58785L10.2812 5.69984C9.164 5.6825 8.52314 5.82742 8.36046 6.11627C8.19228 6.4149 8.22355 6.77792 8.45921 7.20915L8.34588 7.25809C8.09444 6.79799 8.0601 6.3994 8.24779 6.06614C8.44099 5.7231 9.11894 5.56978 10.2834 5.58785Z"
              fill="white"
            />
            <path
              d="M10.4995 6.58101L10.4349 6.67717C10.1916 6.54804 10.0698 6.32766 10.0698 6.02396C10.0698 5.58748 10.3228 5.33153 10.8823 5.15637C11.2394 5.04458 11.7272 5.09041 12.3471 5.29019L12.3042 5.39548C11.7091 5.2037 11.2486 5.16044 10.9242 5.26201C10.4109 5.42267 10.1958 5.64034 10.1958 6.02396C10.1958 6.29047 10.297 6.47352 10.4995 6.58101Z"
              fill="white"
            />
            <path
              d="M8.61802 7.03745L8.38026 7.11168C8.13357 6.48733 8.20402 6.06332 8.62555 5.88041C8.99699 5.71924 9.53832 5.65365 10.2522 5.67937L10.242 5.90319C9.5661 5.87884 9.06322 5.93977 8.7361 6.08171C8.45907 6.20191 8.4084 6.5069 8.61802 7.03745Z"
              fill="#C88A02"
            />
            <path
              d="M11.3958 5.43872C10.8196 5.43872 10.583 5.56346 10.4478 5.93174C10.3617 6.16644 10.4452 6.36676 10.7161 6.55374L10.5616 6.73066C10.2109 6.48858 10.0872 6.1921 10.2083 5.86227C10.3805 5.39292 10.7185 5.21472 11.3958 5.21472C11.8396 5.21472 12.1854 5.31838 12.4262 5.52934L12.4637 5.56224V6.6422H12.2117V5.65798C12.0237 5.5128 11.7536 5.43872 11.3958 5.43872Z"
              fill="#C88A02"
            />
            <path
              d="M14.6804 5.69985L14.6826 5.81183C15.7999 5.7945 16.4407 5.93942 16.6034 6.22827C16.7716 6.5269 16.7403 6.88992 16.5047 7.32115L16.618 7.37009C16.8694 6.90999 16.9038 6.5114 16.7161 6.17814C16.5229 5.83509 15.8449 5.68178 14.6804 5.69985Z"
              fill="white"
            />
            <path
              d="M14.2861 6.60426L14.3507 6.70043C14.594 6.57129 14.7158 6.35092 14.7158 6.04722C14.7158 5.61074 14.4629 5.35478 13.9033 5.17962C13.5462 5.06783 13.0584 5.11367 12.4385 5.31345L12.4815 5.41874C13.0766 5.22696 13.537 5.18369 13.8615 5.28526C14.3747 5.44592 14.5898 5.6636 14.5898 6.04722C14.5898 6.31373 14.4887 6.49677 14.2861 6.60426Z"
              fill="white"
            />
            <path
              d="M16.4245 7.14939L16.6622 7.22362C16.9089 6.59927 16.8385 6.17526 16.4169 5.99235C16.0455 5.83118 15.5042 5.76559 14.7902 5.79131L14.8004 6.01513C15.4764 5.99078 15.9793 6.05171 16.3064 6.19365C16.5834 6.31385 16.6341 6.61884 16.4245 7.14939Z"
              fill="#C88A02"
            />
            <path
              d="M13.6325 5.45606C14.2087 5.45606 14.4453 5.58079 14.5805 5.94908C14.6666 6.18378 14.5831 6.38409 14.3122 6.57108L14.4667 6.748C14.8175 6.50592 14.9411 6.20943 14.82 5.8796C14.6478 5.41025 14.3098 5.23206 13.6325 5.23206C13.1887 5.23206 12.8429 5.33571 12.6021 5.54667L12.5646 5.57957V6.65954H12.8166V5.67531C13.0046 5.53014 13.2747 5.45606 13.6325 5.45606Z"
              fill="#C88A02"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.40625 9.26404H16.5963V15.8049C16.5963 15.8049 15.9879 18 12.5013 18C9.01462 18 8.40625 15.747 8.40625 15.747V9.26404Z"
              fill="#E1E5E8"
            />
            <mask
              id="mask4_800_124140"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="8"
              y="9"
              width="9"
              height="9"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.40625 9.26404H16.5963V15.8049C16.5963 15.8049 15.9879 18 12.5013 18C9.01462 18 8.40625 15.747 8.40625 15.747V9.26404Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_800_124140)">
              <rect
                x="8.40625"
                y="13.296"
                width="4.158"
                height="4.368"
                fill="#FFC034"
              />
              <rect
                x="8.91016"
                y="13.52"
                width="0.504"
                height="4.144"
                fill="#AD1619"
              />
              <rect
                x="10.6743"
                y="13.52"
                width="0.504"
                height="4.144"
                fill="#AD1619"
              />
              <rect
                x="9.79248"
                y="13.52"
                width="0.504"
                height="4.144"
                fill="#AD1619"
              />
              <rect
                x="11.5562"
                y="13.52"
                width="0.504"
                height="4.144"
                fill="#AD1619"
              />
              <rect
                x="8.40625"
                y="9.15204"
                width="4.158"
                height="4.256"
                fill="#AD1619"
              />
              <rect
                x="12.4385"
                y="13.1841"
                width="4.158"
                height="4.256"
                fill="#AD1619"
              />
              <rect
                x="12.4385"
                y="9.26404"
                width="4.41"
                height="4.144"
                fill="#F1F9FF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.1707 9.60004H10.5487V10.5292H10.8006V10.0646H11.1786V10.5292H11.5566V11.11H11.1787V12.1553H11.5566V12.736H9.28857V12.1553H9.66667V11.11H9.28857V10.5292H9.5406V10.0646H9.9186V10.5292H10.1707V9.60004Z"
                fill="#C88A02"
              />
              <path
                d="M14.6016 9.7951L14.8596 9.54956L15.4013 9.99939L15.1433 10.2449L14.6016 9.7951Z"
                fill="#C88A02"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1554 16.1401V13.688H13.0054V16.1196L13.0104 16.1385C13.1698 16.7425 13.7129 17.048 14.5804 17.048C15.447 17.048 15.99 16.7504 16.1501 16.1595L16.1554 16.1401ZM14.5804 16.712C13.8843 16.712 13.5042 16.5036 13.3834 16.08V14.024H15.7774V16.0994C15.6568 16.5093 15.2767 16.712 14.5804 16.712Z"
                fill="#FFC034"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7103 13.8929H14.4478V15.0046L13.413 14.0042L13.2275 14.1558L14.1634 15.0605H13.3154V15.3965H13.9667H14.184L13.2275 16.3212L13.4131 16.4728L14.4478 15.4724V16.7718H14.7103V15.5893L15.6242 16.4728L15.8097 16.3212L14.8533 15.3965H15.9208V15.0605H14.8739L15.8097 14.1558L15.6242 14.0042L14.7103 14.8877V13.8929Z"
                fill="#FFC034"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1683 17.4427C15.1683 17.4427 12.4996 17.6292 12.4996 16.0992C12.4996 16.0992 12.4741 17.4427 9.6875 17.4427V18.6505H15.1683V17.4427Z"
                fill="#F1F9FF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5012 14.192C13.0231 14.192 13.4462 13.7909 13.4462 13.296C13.4462 12.8012 13.0231 12.4 12.5012 12.4C11.9792 12.4 11.5562 12.8012 11.5562 13.296C11.5562 13.7909 11.9792 14.192 12.5012 14.192Z"
                fill="#005BBF"
                stroke="#AD1619"
                strokeWidth="1.16667"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124140">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Spain;
